











































import Vue from 'vue';
import firebase from 'firebase/app';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';

export default Vue.extend({
  components: {},
  methods: {},
  mounted() {
  },
});
